import {getUserSessionService} from '@vio/core/src/auth/services'

export const getAuthHeaders = async (): Promise<Record<string, string>> => {
  try {
    const {idToken} = await getUserSessionService()
    if (idToken) {
      return {Authorization: `Bearer ${idToken.toString()}`}
    }
  } catch {
    // User not authenticated — return empty headers
  }
  return {}
}
